import * as CL from '@design-system/component-library';
import { addToCartMsg, t } from '../../common/i18n/index.js';
import { addToBasket } from '../ShoppingBasket/shoppingBasketFunctionsCoCo.js';
import type { ProductOfferingCartItems } from '../../common/types/shoppingBasketCoCo.js';
import type { ReactElement } from 'react';

interface AccessoryProductCardCoCoProps {
  basketItem: ProductOfferingCartItems;
  productName: string;
  productImage: ReactElement;
  productPrice: ReactElement;
  onProductClick: () => void;
}

export const AccessoryProductCardCoCo = ({
  basketItem,
  productName,
  productImage,
  productPrice,
  onProductClick,
}: AccessoryProductCardCoCoProps) => {
  const handleAddToBasket = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    addToBasket({
      basketItem: basketItem,
    });
  };

  return (
    <div className="of-accessory-product-card">
      <CL.Button
        className="of-accessory-product-card__add-to-basket"
        color="secondary"
        size="s"
        icon={<CL.Icon icon="add-circle" type="filled" />}
        iconPosition="left"
        onClick={handleAddToBasket}
      >
        {t.JFOS(addToCartMsg)}
      </CL.Button>
      <CL.ProductCard
        productName={productName}
        productImage={productImage}
        productPrice={productPrice}
        onProductClick={onProductClick}
      />
    </div>
  );
};
